const ShopifyCart = () => {
  const scriptURL =
    'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
  const shopifyTranslationElement =
    document.getElementById('shopifyTranslation');

  function ShopifyBuyInit() {
    const client = window.ShopifyBuy.buildClient({
      domain: 'orderbird-online-shop.myshopify.com',
      storefrontAccessToken: 'd942189ec6edbb0a45cbc4aaef26745c',
    });

    if (!shopifyTranslationElement.dataset.translations.length) {
      throw Error('Missing translations for shopify drawer!');
    }
    const translations = JSON.parse(
      shopifyTranslationElement.dataset.translations,
    );

    window.ShopifyBuy.UI.onReady(client).then(function (ui) {
      [].forEach.call(
        document.getElementsByClassName('shopifyButton'),
        function (button) {
          // noinspection DuplicatedCode
          ui.createComponent('product', {
            id: '8026671743241',
            node: button,
            moneyFormat: '%E2%82%AC%7B%7Bamount_with_comma_separator%7D%7D',
            options: {
              product: {
                DOMEvents: {
                  'click .shopify-buy__btn-wrapper .shopify-buy__btn':
                    function () {
                      window.dataLayer.push({ event: 'miniAddToCart' });
                    },
                },
                styles: {
                  product: {
                    '@media (min-width: 601px)': {
                      'max-width': 'calc(25% - 20px)',
                      'margin-left': '20px',
                      'margin-bottom': '50px',
                    },
                  },
                  buttonWrapper: {
                    'margin-top': '0px',
                  },
                  button: JSON.parse(button.dataset.style),
                  quantityInput: {
                    'font-family':
                      'neue-haas-grotesk-text, Arial, Verdana, Tahoma, sans-serif',
                    'font-size': '18px',
                    'padding-top': '17px',
                    'padding-bottom': '17px',
                  },
                },
                contents: {
                  img: false,
                  title: false,
                  price: false,
                },
                text: {
                  button: button.dataset.title,
                  outOfStock: translations.outOfStock,
                  unavailable: translations.unavailable,
                },
              },
              productSet: {
                styles: {
                  products: {
                    '@media (min-width: 601px)': {
                      'margin-left': '-20px',
                    },
                  },
                },
              },
              modalProduct: {
                contents: {
                  img: false,
                  imgWithCarousel: true,
                  button: false,
                  buttonWithQuantity: true,
                },
                styles: {
                  product: {
                    '@media (min-width: 601px)': {
                      'max-width': '100%',
                      'margin-left': '0px',
                      'margin-bottom': '0px',
                    },
                  },
                  button: {
                    'font-size': '18px',
                    'padding-top': '17px',
                    'padding-bottom': '17px',
                    color: 'hsl(222, 100%, 11%)',
                    ':hover': {
                      color: 'hsl(222, 100%, 11%)',
                      'background-color': 'hsl(50, 100%, 45%)',
                    },
                    'background-color': 'hsl(50, 100%, 50%)',
                    ':focus': {
                      'background-color': 'hsl(50, 100%, 45%)',
                    },
                    '[disabled]': {
                      'background-color': 'hsl(50, 100%, 45%)',
                    },
                  },
                  quantityInput: {
                    'font-family':
                      'neue-haas-grotesk-text, Arial, Verdana, Tahoma, sans-serif',
                    'font-size': '18px',
                    'padding-top': '17px',
                    'padding-bottom': '17px',
                  },
                },
              },
              cart: {
                DOMEvents: {
                  'click .shopify-buy__cart-bottom .shopify-buy__btn.shopify-buy__btn--cart-checkout':
                    function () {
                      window.dataLayer.push({ event: 'miniGoToCheckout' });
                      window.dataLayer.push({
                        miniGoToCheckoutQuantity: Number(
                          document
                            .querySelector('iframe[name=frame-cart]')
                            .contentWindow.document.getElementsByClassName(
                              'shopify-buy__quantity',
                            )[0].value,
                        ),
                      });
                    },
                },
                iframe: true,
                styles: {
                  button: {
                    'padding-top': '1rem',
                    'padding-bottom': '1rem',
                    'border-radius': '0.5rem',
                    color: 'hsl(222, 100%, 11%)',
                    'font-family':
                      'neue-haas-grotesk-text, Arial, Verdana, Tahoma, sans-serif',
                    'font-weight': '600',
                    'font-size': '1.125rem',
                    ':hover': {
                      color: 'hsl(222, 100%, 11%)',
                      'background-color': 'hsl(50, 100%, 45%)',
                    },
                    'background-color': 'hsl(50, 100%, 50%)',
                    ':focus': {
                      'background-color': 'hsl(50, 100%, 45%)',
                    },
                  },
                  title: {
                    color: 'hsl(222, 100%, 11%)',
                    'font-family':
                      'neue-haas-grotesk-text, Arial, Verdana, Tahoma, sans-serif',
                    'font-size': '1.125rem',
                    'font-weight': '600',
                  },
                  header: {
                    color: 'hsl(222, 100%, 11%)',
                    'font-family':
                      'neue-haas-grotesk-text, Arial, Verdana, Tahoma, sans-serif',
                    'font-size': '1.125rem',
                  },
                  lineItems: {
                    color: 'hsl(222, 100%, 11%)',
                    'font-family':
                      'neue-haas-grotesk-text, Arial, Verdana, Tahoma, sans-serif',
                    'font-size': '1.125rem',
                  },
                  subtotalText: {
                    color: 'hsl(222, 100%, 11%)',
                    'font-family':
                      'neue-haas-grotesk-text, Arial, Verdana, Tahoma, sans-serif',
                    'font-size': '1.125rem',
                    'font-weight': 'bold',
                  },
                  subtotal: {
                    color: 'hsl(222, 100%, 11%)',
                    'padding-bottom': '1rem',
                    'font-family':
                      'neue-haas-grotesk-text, Arial, Verdana, Tahoma, sans-serif',
                    'font-size': '1.125rem',
                    'font-weight': 'bold',
                  },
                  notice: {
                    color: 'hsl(222, 100%, 11%)',
                    'padding-top': '1rem',
                    'border-top': '1px solid black',
                    'font-family':
                      'neue-haas-grotesk-text, Arial, Verdana, Tahoma, sans-serif',
                    'font-size': '0.75rem',
                    'text-align': 'left',
                  },
                  currency: {
                    color: 'hsl(222, 100%, 11%)',
                  },
                  close: {
                    color: 'hsl(222, 100%, 11%)',
                    ':hover': {
                      color: 'hsl(222, 100%, 11%)',
                    },
                  },
                  empty: {
                    color: 'hsl(222, 100%, 11%)',
                    'font-family':
                      'neue-haas-grotesk-text, Arial, Verdana, Tahoma, sans-serif',
                    'font-size': '1.125rem',
                  },
                  noteDescription: {
                    color: 'hsl(222, 100%, 11%)',
                  },
                  discountText: {
                    color: 'hsl(222, 100%, 11%)',
                  },
                  discountIcon: {
                    fill: 'hsl(222, 100%, 11%)',
                  },
                  discountAmount: {
                    color: 'hsl(222, 100%, 11%)',
                  },
                },
                text: translations,
                popup: true,
              },
              toggle: {
                DOMEvents: {
                  load: function () {
                    window.dataLayer.push({ event: 'miniOpenMiniCart' });
                  },
                },
                styles: {
                  toggle: {
                    'background-color': 'hsl(50, 100%, 50%)',
                    ':hover': {
                      'background-color': 'hsl(50, 100%, 45%)',
                    },
                    ':focus': {
                      'background-color': 'hsl(50, 100%, 45%)',
                    },
                  },
                  count: {
                    'font-size': '18px',
                    color: 'hsl(222, 100%, 11%)',
                    ':hover': {
                      color: 'hsl(222, 100%, 11%)',
                    },
                  },
                  iconPath: {
                    fill: 'hsl(222, 100%, 11%)',
                  },
                },
              },
              lineItem: {
                styles: {
                  variantTitle: {
                    color: 'hsl(222, 100%, 11%)',
                  },
                  title: {
                    color: 'hsl(222, 100%, 11%)',
                  },
                  price: {
                    color: 'hsl(222, 100%, 11%)',
                  },
                  fullPrice: {
                    color: 'hsl(222, 100%, 11%)',
                  },
                  discount: {
                    color: 'hsl(222, 100%, 11%)',
                  },
                  discountIcon: {
                    fill: 'hsl(222, 100%, 11%)',
                  },
                  quantity: {
                    color: 'hsl(222, 100%, 11%)',
                  },
                  quantityIncrement: {
                    color: 'hsl(222, 100%, 11%)',
                    'border-color': 'hsl(222, 100%, 11%)',
                  },
                  quantityDecrement: {
                    color: 'hsl(222, 100%, 11%)',
                    'border-color': 'hsl(222, 100%, 11%)',
                  },
                  quantityInput: {
                    color: 'hsl(222, 100%, 11%)',
                    'border-color': 'hsl(222, 100%, 11%)',
                  },
                },
              },
            },
          });
        },
      );
    });
  }

  function loadScript() {
    // load the shopify script only for header type: `minimalMini`
    if (!shopifyTranslationElement) {
      return;
    }
    const script = document.createElement('script');
    script.async = true;
    script.src = scriptURL;
    (
      document.getElementsByTagName('head')[0] ||
      document.getElementsByTagName('body')[0]
    ).appendChild(script);
    script.onload = ShopifyBuyInit;
  }

  if (window.ShopifyBuy && window.ShopifyBuy.UI) {
    ShopifyBuyInit();
  } else {
    loadScript();
  }
};

export default ShopifyCart();
